import { ArchiveMutation } from "../../../../hooks/useArchiveState";
import { PatientAssessmentControllerXApi } from "../../../../services";
import {
  getConfigObject,
  useMutationWithLoading,
} from "../../../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */
export const useArchivePatientAssessment = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new PatientAssessmentControllerXApi(
      getConfigObject()
    ).updatePatientAssessmentArchiveStatus(
      param.id,
      param.status,
      param.xTENANTID //xTENANTID
    )
  );
